// Date-range presets for history filter bars (00-ds-09 §3, D148).
// The actual date math + server filtering is backend (§8); these are the
// UI-visible labels and the preset the filter bar shows by default.

export type HistoryDatePreset =
  | 'this-month'
  | 'last-month'
  | 'last-90'
  | 'this-year'
  | 'all-time'
  | 'custom';

export const HISTORY_DATE_PRESETS: { value: HistoryDatePreset; label: string }[] = [
  { value: 'this-month', label: 'This month' },
  { value: 'last-month', label: 'Last month' },
  { value: 'last-90', label: 'Last 90 days' },
  { value: 'this-year', label: 'This year' },
  { value: 'all-time', label: 'All time' },
  { value: 'custom', label: 'Custom range' },
];

/** Default window for a history list (§3: "Default window: this month"). */
export const DEFAULT_HISTORY_PRESET: HistoryDatePreset = 'this-month';
